import { render, staticRenderFns } from "./FormsEmptyContent.vue?vue&type=template&id=347b0bce&scoped=true&"
import script from "./FormsEmptyContent.vue?vue&type=script&lang=js&"
export * from "./FormsEmptyContent.vue?vue&type=script&lang=js&"
import style0 from "./FormsEmptyContent.vue?vue&type=style&index=0&id=347b0bce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347b0bce",
  null
  
)

export default component.exports